exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QAS4pFKCqswPU5fpvcIOX{cursor:pointer;font-size:14px;font-weight:400;color:\"[theme:themePrimary, default:#0078D7]\";font-weight:600;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir] .QAS4pFKCqswPU5fpvcIOX{padding-top:2px;margin:auto}._1Q6qmbDfVktTkuve0L8XsX{font-weight:400;font-size:10px;color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=ltr] ._1Q6qmbDfVktTkuve0L8XsX{padding-left:4px}html[dir=rtl] ._1Q6qmbDfVktTkuve0L8XsX{padding-right:4px}", ""]);

// exports
exports.locals = {
	"filter": "QAS4pFKCqswPU5fpvcIOX",
	"icon": "_1Q6qmbDfVktTkuve0L8XsX"
};